export const getCookie = () => {
  let cookie = document.cookie;

  cookie = cookie.split('; ');
  let result = {};
  for (let i = 0; i < cookie.length; i++) {
      const cur = cookie[i].split('=');
      result[cur[0]] = cur[1];
  }

  const jwt = result["auth"]

  if (!jwt) {
    logout();
  }

  return jwt;
};

export const logout = () => {
  localStorage.clear();
  document.cookie =
    document.cookie + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};
